import { Linking } from "react-native";
import { getPathFromState } from "../fork/getPathFromState";
import { getStateFromPath } from "../fork/getStateFromPath";
function getInitialURL() {
  return Promise.race([
    (async function() {
      var url = await Linking.getInitialURL();
      return url !== null && url !== void 0 ? url : getRootURL();
    })(),
    new Promise(function(resolve) {
      return (
        // Timeout in 150ms if `getInitialState` doesn't resolve
        // Workaround for https://github.com/facebook/react-native/issues/25675
        setTimeout(function() {
          return resolve(getRootURL());
        }, 150)
      );
    })
  ]);
}
function getRootURL() {
  return "/";
}
function getDefaultLinkingPrefixes() {
  return [];
}
function addEventListener(listener) {
  var subscription = Linking.addEventListener("url", function(param) {
    var { url } = param;
    return listener(url);
  });
  return function() {
    var _subscription_remove;
    subscription === null || subscription === void 0 ? void 0 : (_subscription_remove = subscription.remove) === null || _subscription_remove === void 0 ? void 0 : _subscription_remove.call(subscription);
  };
}
export {
  addEventListener,
  getDefaultLinkingPrefixes,
  getInitialURL,
  getPathFromState,
  getRootURL,
  getStateFromPath
};
//# sourceMappingURL=linking.native.js.map
